import styled from 'styled-components';

export const ListElement = styled.div.attrs({
  className: 'ListElement',
  maxwidth: props => props.maxwidth || '726px',
  padding: props => props.padding
})`
  width: 100%;
  max-width: ${props => props.maxwidth};
  border-radius: 5px;
  /* background: yellowgreen; */
  /* padding: 1.125rem; */
  /* padding: 18px 5px; */
  padding: ${props => props.padding};
  box-sizing: border-box;
  background: white;
`;
/* ${mediaMax.desktop`width: 95%;`}; */
